// Please also update in `order-email.service.ts` when adding new email addresses.
export const settings = {
  frost: 'sales@frost.is',
  gosens: 'info@gosens-koeltechniek.nl',
  koledanmark: 'info@koledanmark.dk',
  coldroomdk: 'sales@coldroom.dk',
  koelcelwinkel: 'info@koelcelwinkel.nl',
  kingspan: 'admin@kingspan.com',
  kingspangroup: 'admin@kingspan.com',
};
